import { render, staticRenderFns } from "./BillboardAndIndividual.vue?vue&type=template&id=19da8aa4&scoped=true&"
import script from "./BillboardAndIndividual.vue?vue&type=script&lang=js&"
export * from "./BillboardAndIndividual.vue?vue&type=script&lang=js&"
import style0 from "./BillboardAndIndividual.vue?vue&type=style&index=0&id=19da8aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da8aa4",
  null
  
)

export default component.exports